export default __webpack_public_path__ + "static/media/m4v.55d956f5.svg";